import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import type {TranscriptionStatus} from 'nutshell-graphql-types';

type Props = {
    canTranscribe: boolean;
    shouldTranscribe: boolean;
    setShouldTranscribe: (arg1: boolean) => void;
    hasAvailableSummaries: boolean;
    setIsFeatureGateModalOpen: (arg1: boolean) => void;
    transcription: string | null | undefined;
    transcriptionStatus: TranscriptionStatus;
};

export function TranscriptionSection(props: Props) {
    if (!props.canTranscribe) {
        return (
            <div className='border br-3 px-16 py-8'>
                <Body size='small'>
                    This call cannot be transcribed because it was not recorded.
                </Body>
            </div>
        );
    }

    let transcriptionContent;
    switch (props.transcriptionStatus) {
        case 'PROCESSING':
            transcriptionContent = (
                <div className='border br-3 px-16 py-8 background-offwhite flex flex-dir-col gap-8'>
                    <Body size='small'>Transcription is processing…</Body>
                    <LoadingText width={450} />
                    <LoadingText width={480} />
                </div>
            );
            break;
        case 'FAILED':
            transcriptionContent = (
                <div className='border br-3 px-16 py-8 background-offwhite'>
                    <Body size='small'>Transcription failed.</Body>
                </div>
            );
            break;
        case 'PROCESSED':
            transcriptionContent = (
                <div
                    className='border br-3 px-16 py-8 background-offwhite'
                    style={{maxHeight: '140px', overflow: 'auto'}}
                >
                    <Body size='small' maintainLineBreaks={true} preventCopy={true}>
                        {props.transcription}
                    </Body>
                </div>
            );
    }

    if (!props.hasAvailableSummaries) {
        return (
            <StackLegacy spacing={4}>
                <StackLegacy isHorizontal={true} spacing={0}>
                    <Body size='small'>Summary</Body>
                    <button type='button' onClick={() => props.setIsFeatureGateModalOpen(true)}>
                        <UpgradeArrowIcon size={16} color={colors.blue} />
                    </button>
                </StackLegacy>
                <div className='border br-3 px-16 py-8'>
                    <Body size='small'>You are out of summarization credits for the month.</Body>
                </div>
            </StackLegacy>
        );
    }

    return (
        <StackLegacy spacing={8}>
            <Checkbox
                label='Include this transcription'
                checked={props.shouldTranscribe}
                onChange={(checked) => props.setShouldTranscribe(checked)}
            />
            {transcriptionContent}
        </StackLegacy>
    );
}
